import moment from 'moment'
import { Expose, Transform, Type } from 'class-transformer'
import { Truck } from 'react-feather'

import { Address } from './Address'
import { Base } from './Base'
import { Carrier } from './Carrier'
import { Client } from './Client'
import { Facility } from './Facility'
import { Order } from './Order'
import { Truckload } from './Truckload'

export class Shipment extends Base {
  static type = 'shipment'
  static typeDisplay = 'Shipment'
  static icon = Truck

  type = Shipment.type
  typeDisplay = Shipment.typeDisplay
  icon = Shipment.icon

  @Expose({ name: 'xid' })
  guid: string = ''

  name: string = ''

  @Expose({ name: 'tracking_number' })
  trackingNumber?: string

  @Expose({ name: 'internal_notes' })
  internalNotes?: string

  @Type(() => Client)
  client?: Client

  @Type(() => Facility)
  facility?: Facility

  @Type(() => Order)
  order?: Order

  @Type(() => Truckload)
  truckload?: Truckload

  consignee?: string

  @Type(() => Address)
  address?: Address

  @Type(() => Carrier)
  carrier?: Carrier

  status?: string

  @Expose({ name: 'shipped_on' })
  @Transform((value) => (value ? moment(value) : value))
  shippedOn?: moment.Moment

  @Expose({ name: 'delivered_on' })
  @Transform((value) => moment(value))
  deliveredOn?: moment.Moment

  @Expose({ name: 'canceled_on' })
  @Transform((value) => moment(value))
  cancelledOn?: moment.Moment
}
